import { cn } from '../../lib/utils';

export function ProgressBar({ value, className }: { value: number; className?: string }) {
  const clamped = Math.max(0, Math.min(100, value));
  return (
    <div className={cn('h-2 w-full overflow-hidden rounded-full bg-gray-100 dark:bg-gray-800', className)}> {/* dark: ADDED FOR THEME */}
      <div
        className="h-full rounded-full bg-blue-600 transition-all duration-500"
        style={{ width: `${clamped}%` }}
      />
    </div>
  );
}
